<template>
  <MissionContainer>
    <h1>Bien réussir mon rendez-vous chez l'opticien</h1>

    <ContextBlock>Bienvenue sur notre programme Optique Viasanté ! Vous avez pris rendez-vous avec un de nos Conseillers Optique. Pour bien préparer votre rendez-vous, nous vous proposons de lui faire parvenir à l'avance les documents les plus importants à prévoir : votre ordonnance lunettes et votre carte de Mutuelle Viasanté.</ContextBlock>
    <ObjectivesBlock>Communiquer à l'avance les éléments importants à mon Conseiller Optique Viasanté pour bien réussir mon rendez-vous.</ObjectivesBlock>
    <InstructionsBlock>
      <p>Pour réaliser cette mission, vous devez :</p>
      <ol>
        <li>Scanner ou prendre en photo votre ordonnance lunettes et de votre carte de Mutuelle Viasanté</li>
        <li>Téléverser les deux documents images en ajoutant éventuellement un commentaire libre</li>
        <li>VALIDER la mission</li>
      </ol>
    </InstructionsBlock>
    <p>Ajouter ici la photo ou le scan de votre ordonnance et votre carte mutuelle :</p>
    <v-file-input v-model="missionData.files" color="primary" label="Fichiers" multiple outlined @change="handleFiles"></v-file-input>
    <p>Ajouter ici un commentaire personnel :</p>
    <v-textarea outlined v-model="missionData.comments"></v-textarea>

    <FinishMissionButtonBlock @click.native="finishMission">Valider la mission</FinishMissionButtonBlock>
  </MissionContainer>
</template>

<script>
import api from "api";
import ContextBlock from "components/blocks/ContextBlock";
import FinishMissionButtonBlock from "components/blocks/FinishMissionButtonBlock";
import InstructionsBlock from "components/blocks/InstructionsBlock";
import MissionContainer from "components/blocks/MissionContainer";
import ObjectivesBlock from "components/blocks/ObjectivesBlock";

export default {
  components: { FinishMissionButtonBlock, InstructionsBlock, ObjectivesBlock, ContextBlock, MissionContainer },
  data: () => ({
    ui: {
      loading: false,
    },
    missionData: {
      tempFilesUuids: [],
      files: [],
      comments: null
    }
  }),

  methods: {
    handleFiles(event) {
      Array.from(event.target.files).forEach(file => {
        if (file.size < 50000000) {
          let formData = new FormData()
          formData.set('file', file, file.name)

          api.postFormData('/tempfile', formData)
            .then(res => {
              this.tempFilesUuids.push(res.data)
            })
        } else {
          alert(`${file.name} n'a pas été ajouté car dépasse la taille autorisée (50M max)`)
        }
      })
    },

    finishMission() {
      this.ui.loading = true
      this.errors = {}

      api.post(`missions/${this.mission.id}`, this.missionData)
        .then(res => {
          this.$mango.snackbar({
            color: 'success',
            text: "Mission validée. Bravo !"
          })
          this.$router.push({name: 'patient@dashboard'})
        })
        .catch(err => {
          this.$mango.snackbar({
            color: 'error',
            text: "Erreur de validation. Veuillez vérifier le formulaire."
          })
        })
        .then(() => {
          this.ui.loading = false
        })
    }
  },

  props: {
    mission: {
      required: true,
      type: Object
    }
  }
};
</script>
